import { useState, useEffect } from 'react';
import { fetchSlotUnitEconomics } from '../../../data/machinesApi';

// Prices and cost rules change at most daily, so a lane opened again in this session renders without a request
const cache = new Map();

const useSlotUnitEconomics = (storeId, productId, clientId, row, column) => {
  const key = storeId && productId && clientId ? `${clientId}:${storeId}:${productId}:${row}:${column}` : null;
  const [fetched, setFetched] = useState({ key: null, data: null });

  useEffect(() => {
    if (!key || cache.has(key)) return;

    let cancelled = false;
    fetchSlotUnitEconomics(clientId, storeId, productId, row, column)
      .then(result => {
        cache.set(key, result);
        if (!cancelled) setFetched({ key, data: result });
      })
      .catch(() => {
        if (!cancelled) setFetched({ key, data: null });
      });

    return () => { cancelled = true; };
  }, [key, clientId, storeId, productId, row, column]);

  if (!key) return { data: null, loading: false };
  if (cache.has(key)) return { data: cache.get(key), loading: false };
  return { data: fetched.key === key ? fetched.data : null, loading: fetched.key !== key };
};

export default useSlotUnitEconomics;
